import { Flex, Separator, Text } from '@chakra-ui/react';
import React from 'react';

type Props = {
  text: string;
};

export const TextBorder: React.FC<Props> = (props) => {
  return (
    <Flex w="full" flexDir="row" align="center">
      <Separator border="1px" color="border" flex={1} />
      <Text
        fontSize="16px"
        fontWeight="bold"
        px="16px"
        w="full"
        textAlign="center"
        flex={2}
      >
        {props.text}
      </Text>
      <Separator border="1px" color="border" flex={1} />
    </Flex>
  );
};
